import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(theme => ({
  LogoJ: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'white',
    color: '#444',
    borderRadius: '50%',
    width: '70px',
    height: '70px',
    marginTop: '-1em',
    marginBottom: '0.5em',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  text: {
    fontSize: '3rem',
    color: '#444',
    fontWeight: 200,
  },
}));

const Logo = () => {
  const classes = useStyles();

  return (
    <div className={classes.LogoJ}>
      <p className={classes.text}>J</p>
    </div>
  );
};

export default Logo;
